import { AnyObject } from 'final-form';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import Ownership from 'src/models/tract_detail/Ownership';

interface ILeaseBuyerFormProps {
    selectedOwnershipIds: Array<number>;
    ownerDetail: LeaseGenerationOwnerData;
    ownership: Ownership;
    leaseBuyers: Array<{ value: number; label: string }>;
    saveComplete: boolean;

    onSubmit: (data: { leaseBuyer: number }, event: React.FormEvent<HTMLFormElement>) => void;
}

const LeaseBuyerForm = (props: ILeaseBuyerFormProps) => {
    const { register, handleSubmit } = useForm();
    const [leaseBuyerSelected, setLeaseBuyerSelected] = useState<boolean>(false);
    const [leaseBuyerList, setLeaseBuyerList] = useState<Array<{ value: number; label: string }>>([]);

    useEffect(() => {
        if (props.leaseBuyers?.length > 0) {
            let buyerList = [{ value: 0, label: '(Remove Lease Buyer)'}];
            buyerList = buyerList.concat(props.leaseBuyers);
            setLeaseBuyerList(buyerList);
        }
    }, [props.leaseBuyers]);

    const showSelectedGlobalIds = () => {
        if (props.selectedOwnershipIds.length > 0) {
            return props.selectedOwnershipIds.map((selectedOwnershipId: number, index) => {
                const tempTract = props.ownerDetail?.tracts.find((x) => x.ownershipId === selectedOwnershipId);
                if (tempTract) {
                    const tempGlobalId = `${tempTract.sectionNumber}.${tempTract.tractNumber}-${tempTract.horizonNumber}`;
                    return (
                        <>
                            <span key={index}>{tempGlobalId}</span>
                            {index < props.selectedOwnershipIds.length - 1 ? <span>, </span> : null}
                        </>
                    );
                } else {
                    return <span />;
                }
            });
        } else {
            return <span />;
        }
    };

    const onLeaseBuyerSelected = (event: AnyObject) => {
        setLeaseBuyerSelected(event.target.value !== '-- Select --');
    };

    return (
        <div style={{ width: '50%', borderRight: '1px solid grey', margin: '.5rem', paddingRight: '1rem' }}>
            <>
                <form onSubmit={handleSubmit(props.onSubmit)}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>Note</div>
                        <div>
                            <span style={{ marginRight: '1rem' }}>Attached Tracts:</span>
                            {showSelectedGlobalIds()}
                        </div>
                    </div>
                    <RHFSelect
                        name="leaseBuyer"
                        label="Lease Buyer"
                        options={leaseBuyerList}
                        register={register}
                        style={{ width: '100%' }}
                        onChange={(e) => onLeaseBuyerSelected(e)}
                    />
                    <br />
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <input
                            type="submit"
                            value={props.saveComplete ? 'Save Complete!' : 'Save'}
                            style={
                                props.selectedOwnershipIds?.length > 0 && leaseBuyerSelected
                                    ? { border: '0', backgroundColor: '#6393C1', color: 'white', height: '3rem' }
                                    : { border: '0', backgroundColor: '#bbbbbb', color: 'darkgrey', height: '3rem' }
                            }
                            disabled={!(props.selectedOwnershipIds?.length > 0 && leaseBuyerSelected)}
                        />
                        {props.selectedOwnershipIds?.length === 0 && <div>No Tracts selected</div>}
                    </div>
                </form>
            </>
        </div>
    );
};

export default  LeaseBuyerForm;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/LeaseBuyerForm.tsx